import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  margin-top: 20px;
  padding-bottom: 30px;
  padding-right: 15px;
  padding-left: 15px;
`;
